import { all, takeEvery, select, put, race, take, debounce } from 'redux-saga/effects'
import log from 'loglevel'

import { getSessionId } from '@global/selectors'

import {
    TOGGLE_BUTTONS_ARRAY_BUTTON,
    CHANGE_BUTTONS_ARRAY_BUTTON,
} from '../../scenes/Gnosus/components/Ribbon/components/ButtonsArray/components/ConnectButton/constants'
import { ACTIVE_RIBBON_DROPDOWN_ITEM } from '../../scenes/Gnosus/components/Ribbon/components/DropDown/constants'
import { EXPORTS_UPDATE_APP_STATE } from '../../scenes/Gnosus/components/EntityStack/components/StackContent/components/ExportsContent/constants'

import {
    GET_APP_STATE,
    GET_APP_STATE_REQUEST,
    POST_APP_STATE_REQUEST,
    POST_APP_STATE,
    appStateModules,
} from './constants'
import { getAppStateRequest, updateAppState, postAppState, postAppStateRequest, setNewAppState } from './actions'
import { getRibbonBlocks, getAppState, getSuccessfulJobs } from './selectors'

export function* getAppStateCallSaga() {
    const sessionId = yield select(getSessionId)

    const request = yield all({
        action: put(getAppStateRequest(sessionId)),
        response: race({
            success: take(`${GET_APP_STATE_REQUEST}_SUCCESS`),
            failed: take(`${GET_APP_STATE_REQUEST}FAILED`),
        }),
    })

    if (request.response.failed) {
        log.warn('App-state request failed', { request })
        return null
    }

    const appState = request.response.success.payload.response?.body?.appState

    yield put(setNewAppState(appState))

    return null
}

// When any block button in ribbon is toggled
export function* blockActivityToggleSaga(action) {
    const moduleName = action?.data?.moduleName
    const arrayName = action?.data?.arrayName
    const ribbonBlocks = yield select(getRibbonBlocks, moduleName, arrayName)

    yield put(updateAppState(moduleName, 'ribbonActiveBlocks', ribbonBlocks))

    yield put(postAppState())

    return null
}

// When user selects a different report/portfolio type
// This will also call blockActivityToggleSaga since changing report/portfolio type
// changes ribbon block buttons
export function* privilegesTypeChangeSaga(action) {
    const moduleName = action?.data?.moduleName
    const value = action?.data?.name

    yield put(updateAppState(moduleName, 'activeType', value))

    yield put(postAppState())
}

export function* exportsCallSaga() {
    const successfulJobs = yield select(getSuccessfulJobs)

    yield put(updateAppState(appStateModules.exports, 'jobs', successfulJobs))

    yield put(postAppState())
}

export function* postAppStateCallSaga() {
    const appState = yield select(getAppState)
    const sessionId = yield select(getSessionId)

    const request = yield all({
        action: put(postAppStateRequest(appState, sessionId)),
        response: race({
            success: take(`${POST_APP_STATE_REQUEST}_SUCCESS`),
            failed: take(`${POST_APP_STATE_REQUEST}FAILED`),
        }),
    })

    if (request.response.failed) {
        log.warn('App-state request failed', { request })
        return null
    }

    return null
}

export default function* appStateSaga() {
    yield all([
        takeEvery(GET_APP_STATE, getAppStateCallSaga),
        takeEvery(POST_APP_STATE, postAppStateCallSaga),
        debounce(1000, TOGGLE_BUTTONS_ARRAY_BUTTON, blockActivityToggleSaga),
        debounce(1000, CHANGE_BUTTONS_ARRAY_BUTTON, blockActivityToggleSaga),
        takeEvery(ACTIVE_RIBBON_DROPDOWN_ITEM, privilegesTypeChangeSaga),
        takeEvery(EXPORTS_UPDATE_APP_STATE, exportsCallSaga),
    ])
}
